import { Box, Button, Card } from '@mui/material'

import { useEffect, useState } from 'react'
import WTypography from 'Components/whiteTypography'
import { Doughnut } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

// LAP-PAT1 — les 5 vues du patrimoine (calculées côté back : oldData.vues)
const VUES_KEYS = ['net_total', 'liquide', 'investissable', 'retraite', 'productif']

function MonPatrimoineCard({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [actifs, setActifs] = useState(true)
  const [vue, setVue] = useState(null) // LAP-PAT1 — vue sélectionnée (null = donut)
  const [total, setTotal] = useState(0)
  const [revData, setRevData] = useState({
    labels: [],

    datasets: [
      {
        data: [],
        backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderWidth: 1,
        hoverOffset: 4,
        precision: 0,
      },
    ],
  })
  const optiondonut = {
    responsive: true,
    aspectRatio: 1.3,
    clip: true,
    cutout: '0%',
    plugins: {
      datalabels: {
        formatter: function (value, ctx) {
          return ctx.chart.data.labels[ctx.dataIndex] + '\n' + [parseFloat(value).toFixed(2) + '%']
        },
        textAlign: 'center',
        color: 'white',
        anchor: 'center',
        clamp: true,
        display: 'auto',
      },

      legend: {
        display: true,
        position: 'bottom',
        responsive: true,
        events: [],
        labels: {
          boxWidth: 10,
          color: 'white',
        },
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
        },
      },
    },
  }

  useEffect(() => {
    setTotal(oldData?.actifs?.total)
    setRevData({
      labels: oldData?.actifs?.labels,
      datasets: [
        {
          data: oldData?.actifs?.data,

          backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
          borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
          borderWidth: 1,
          hoverOffset: 4,
          precision: 0,
        },
      ],
    })
  }, [oldData])
  const handelMon = (val) => {
    if (val) {
      setTotal(oldData?.actifs?.total)
      setRevData({
        labels: oldData?.actifs?.labels,
        datasets: [
          {
            data: oldData?.actifs?.data,

            backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderWidth: 1,
            hoverOffset: 4,
            precision: 0,
          },
        ],
      })
    } else {
      setTotal(oldData?.passifs?.total)
      setRevData({
        labels: oldData?.passifs?.labels,
        datasets: [
          {
            data: oldData?.passifs?.data,

            backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderWidth: 1,
            hoverOffset: 4,
            precision: 0,
          },
        ],
      })
    }
    setActifs(val)
  }
  // LAP-PAT1 — sélection d'une vue du patrimoine (2e clic = retour au total)
  const handleVue = (key) => {
    setVue(vue === key ? null : key)
  }
  const vues = oldData?.vues
  const displayedTotal =
    vue && vues ? Number(vues[vue] || 0).toLocaleString('fr-FR') : total
  const subtitle = vue
    ? t(`monPatrimoine.vuesDesc.${vue}`)
    : actifs
    ? t('monPatrimoine.distributionOfAssets')
    : t('monPatrimoine.distributionOfLiabilities')
  return (
    <>
      <Card className="dashboard_card__root1">
        <Box className="dashboard_card__header1">
          <WTypography component={'span'} variant="h6">
            {actifs ? t('monPatrimoine.myPatrimoine') : t('monPatrimoine.patrimoine')}
          </WTypography>
          <WTypography component={'span'} variant="h6">
            {displayedTotal}

            <WTypography
              component={'span'}
              sx={{ fontSize: '12px', color: 'white', marginLeft: '4px' }}
            >
              €
            </WTypography>
          </WTypography>
        </Box>
        <Box className="dashboard_card__header1">
          <WTypography sx={{ color: '#ffffffa1' }} variant={'body2'}>
            {subtitle}
          </WTypography>
        </Box>

        {/* LAP-PAT1 — pastilles des 5 vues du patrimoine */}
        {vues && (
          <Box
            className="no-drag"
            sx={{ display: 'flex', flexWrap: 'wrap', gap: '6px', mt: 1, px: 1 }}
          >
            {VUES_KEYS.map((key) => (
              <Button
                key={key}
                size="small"
                onClick={() => handleVue(key)}
                sx={{
                  textTransform: 'none',
                  fontSize: '11px',
                  lineHeight: 1.2,
                  padding: '2px 8px',
                  minWidth: 0,
                  borderRadius: '12px',
                  border: '1px solid',
                  borderColor: vue === key ? '#93b7ff' : '#ffffff33',
                  color: vue === key ? '#93b7ff' : '#ffffffa1',
                  backgroundColor: vue === key ? '#93b7ff1a' : 'transparent',
                }}
              >
                {t(`monPatrimoine.vues.${key}`)}
              </Button>
            ))}
          </Box>
        )}

        <Box minWidth={3} mb={8} height={'70%'}>
          <Box mt={9} className="chart_box no-drag" minWidth={3} mb={6} height={'100%'}>
            <Doughnut data={revData} options={optiondonut} />
          </Box>
        </Box>
        <Box mt={2} pb={1} sx={{ right: '32% !important' }} className="dashboard_card__filters1">
          <Box
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            className="no-drag"
          >
            <Button
              variant=""
              onClick={() => handelMon(true)}
              sx={{ color: actifs ? '#305fb5' : 'white' }}
            >
              {t('monPatrimoine.myAssets')}
            </Button>
            <Button
              variant=""
              onClick={() => handelMon(false)}
              sx={{ color: actifs ? 'white' : '#305fb5' }}
            >
              {t('monPatrimoine.myLiabilities')}
            </Button>
          </Box>
        </Box>
      </Card>
    </>
  )
}

export default MonPatrimoineCard
